// Spotlight tour step catalogue. Each step anchors to a UI element
// via a string key — components register their DOM node by calling
// useTourAnchor(key) and the controller reads the rect at render
// time. If a step's `route` differs from the current location, the
// controller navigates there before showing the popover.
//
// Step entry:
//   id         stable string (key in localStorage / replay UI)
//   anchor     anchor key (must match a useTourAnchor call in the
//              live tree at the time the step is active)
//   route      where the user needs to be for this step (controller
//              navigates if not there)
//   titleKey   i18n key
//   bodyKey    i18n key
//   align      'auto' (default) | 'top' | 'bottom' — popover side
//              relative to the anchor rect. 'auto' picks the side
//              with more room.
//   fallbackAlign  if 'auto' can't decide cleanly, this side wins.

export const TOUR_STEPS = [
  {
    id: 'today-greeting',
    anchor: 'today-greeting',
    route: '/',
    titleKey: 'tour.steps.greeting.title',
    bodyKey:  'tour.steps.greeting.body',
    align: 'bottom',
  },
  {
    id: 'today-checkins',
    anchor: 'today-checkins',
    route: '/',
    titleKey: 'tour.steps.checkins.title',
    bodyKey:  'tour.steps.checkins.body',
    align: 'bottom',
  },
  {
    id: 'today-couples',
    anchor: 'today-couples',
    route: '/',
    titleKey: 'tour.steps.couples.title',
    bodyKey:  'tour.steps.couples.body',
    align: 'top',
  },
  {
    id: 'today-headline',
    anchor: 'today-headline',
    route: '/',
    titleKey: 'tour.steps.headline.title',
    bodyKey:  'tour.steps.headline.body',
    align: 'top',
  },
  {
    id: 'today-modules',
    anchor: 'today-modules',
    route: '/',
    titleKey: 'tour.steps.modules.title',
    bodyKey:  'tour.steps.modules.body',
    align: 'top',
  },
  {
    id: 'bottom-bar',
    anchor: 'bottom-bar',
    route: '/',
    titleKey: 'tour.steps.bottomBar.title',
    bodyKey:  'tour.steps.bottomBar.body',
    align: 'top',
  },
  {
    id: 'profile-tab',
    anchor: 'bottom-bar-profile',
    route: '/',
    titleKey: 'tour.steps.profile.title',
    bodyKey:  'tour.steps.profile.body',
    align: 'top',
  },
]
